import React from 'react';
import SimpleProductPage from './PriceComparison/SimpleProductPage';
import { 
  findProductById, 
 
  getProductImage, 
  getProductCsvLookupId 
} from '../utils/productHelpers';

const SimpleAmpedOutdoors8AhLiFePO4Plus3ACharger = () => {
  console.log('🎯 SimpleAmpedOutdoors8AhLiFePO4Plus3ACharger component loading');
  
  const product = findProductById("amped-8ah-lifepo4-with-charger");
  
  if (!product) {
    console.error('Product not found:', "amped-8ah-lifepo4-with-charger");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="amped-8ah-lifepo4-with-charger"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
    />
  );
};

export default SimpleAmpedOutdoors8AhLiFePO4Plus3ACharger; 